import useAddToOrderButtonStyles from '@components/Product/styles/addToOrderButton.styles';
import type { IconSize } from '@components/v2/types';
import Icon from '@components/v2/ui/Icon/Icon';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import classNames from 'classnames';
import { ChevronDown } from 'lucide-react';
import { ElementType, MouseEvent } from 'react';
import useProductDetailsAddOrderButtonV2Styles from '../styles/productDetailsAddOrderButtonV2.styles';

export type AddOrderIconButtonSize = 'medium' | 'large';

const CHEVRON_SIZE_BY_BUTTON_SIZE: Record<AddOrderIconButtonSize, IconSize> = {
  medium: 'md',
  large: 'lg',
};

interface AddOrderIconButtonProps {
  icon: ElementType;
  size: AddOrderIconButtonSize;
  isInOrder: boolean;
  isShownAsInOrder: boolean;
  disabled: boolean;
  tabIndex: number;
  testId?: string;
  onClick: (event: MouseEvent<HTMLElement>) => void;
}

const AddOrderIconButton = ({
  icon,
  size,
  isInOrder,
  isShownAsInOrder,
  disabled,
  tabIndex,
  testId,
  onClick,
}: AddOrderIconButtonProps) => {
  const { classes } = useProductDetailsAddOrderButtonV2Styles();
  const { classes: inOrderClasses } = useAddToOrderButtonStyles();

  return (
    <IconButton
      size={size}
      icon={icon}
      testId={testId}
      tabIndex={tabIndex}
      disabled={disabled}
      color={isShownAsInOrder ? 'primary' : 'secondary'}
      className={classNames(classes.button, classes[`${size}Width`], {
        [inOrderClasses.inOrder]: isShownAsInOrder,
      })}
      onClick={onClick}
    >
      {isInOrder && <Icon icon={ChevronDown} size={CHEVRON_SIZE_BY_BUTTON_SIZE[size]} />}
    </IconButton>
  );
};

export default AddOrderIconButton;
